var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 116,
    viewBox: "0 0 140 116",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.143 68.22c2.854-3.67 4.28-6.53 4.28-8.577 0-3.072-.514-9.564 3.812-17.53 4.326-7.965 14.18-10.975 22.924-9.113s13.506 6.263 16.117 12.843c1.742 4.386 2.307 10.358 1.696 17.915l-9.575 13.694-20.138 3.37-7.92 2.043-13.67-12.467 2.474-2.177z",
    fill: "#ED1C24",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m81.339 12.02 3.102 10.241M96.518 13.638v8.623M111.16 9.332l-3.526 12.929M136.5 30.5l-11.866 4.761M122.5 22.261l-5.224 5.18M39.33 30.506h5.29M57.745 30.506h-3.571c-2.04.179-3.059 1.262-3.059 3.248v4.743c.015 1.913-.602 2.87-1.852 2.87h-3.214M44.62 45.843c2.708 2.124 5.134 2.124 7.277 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.004 37.28c.482-2.25.723-6.392.723-12.429 0-9.055-9.45-24.004-22.464-20.262-5.643-3.99-25.47 4.009-25.47 17.672s1.944 14.46-.512 20.785c-1.637 4.216-.745 7.613 2.678 10.191-4.523.81-6.785 5.805-6.785 14.984",
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.259 17.14C54.583 24.008 60.497 28.463 66 30.506 66.5 41.367 58.165 55.5 48.259 55.5c-9.907 0-16.389-12.438-16.389-24.994 8.087-3.77 13.55-8.225 16.389-13.366z",
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 52.423c1.024 6.495 4.524 10.273 10.5 11.335M40 53.76c.384 5.498-2.824 8.83-9.625 9.998-10.201 1.75-16.473 11.31-19.063 17.987-1.726 4.452-3.475 10.37-5.246 17.757-1.681 8.311 1.139 12.467 8.46 12.467M2.294 111.969h111.71",
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.87 63.758c.914 6.064 5.164 9.924 12.75 11.578M56 69.547l-7.741 3.235c-.31 8.294.903 14.03 3.638 17.21 2.735 3.178 12.02 9.303 27.853 18.376 14.038 5.505 19.628 2.63 16.768-8.623-2.355-6.287-5.712-11.914-10.072-16.88M27.83 88.982l-3.036 9.766c14.672.624 27.5 2.384 38.482 5.278",
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 78.315 4-6.032c4.868-3.245 6.627-2.3 5.276 2.834-1.35 5.135-2.026 8.516-2.026 10.144l20.089 9.972M66 68.22l15.339 16.018c2.571-2.278 5.211-3.417 7.92-3.417 4.062 0 21.46.182 28.017-11.274 6.558-11.457 6.558-25.16-3.91-34.547-10.47-9.386-30.476-8.823-39.175 5.017-6.522 11.805-3.447 16.554-4.932 20.432A137.128 137.128 0 0 1 66 68.221z",
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.727 72.782c13.597-12.545 21.049-19.89 22.357-22.038 1.962-3.22 2.03-7.47-4.238-7.706-7.35.953-5.27 6.182-3.64 7.706 1.628 1.524 7.175 8.05 10.038 10.532 2.862 2.482 8.8 2.275 8.8-3.186 0-5.46-3.67-6.332-5.938-4.33-1.51 1.336-9.375 9.233-23.593 23.692M69.143 81.42l5.536 5.833 5.024-4.437",
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DF0D15",
    strokeWidth: 3,
    d: "m67.669 70.398-4.393 4.719M73.727 85.608l-3.584 3.374"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF0D15",
    cx: 42,
    cy: 35,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF0D15",
    cx: 56,
    cy: 35,
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaker);
export default __webpack_public_path__ + "static/media/icon-maker.1c1c2e38574d942af0b55c39f91bbf42.svg";
export { ForwardRef as ReactComponent };